angular.module('pe4h').controller('TopbarController', function($scope, $state, $location, $rootScope) {

    $scope.isUser = function(){
        if ($scope.user != undefined){
    	   return $scope.user.IsProfessional;
        }
        else{
            return false;
        }
    }

    $scope.isClient = function(){
    	if ($scope.user != undefined){
           return $scope.user.IsClient;
        }
        else{
            return false;
        }
    }

    $scope.loginTopBar = function(){
        var currentUrl = $location.url();
        // Redirect to project page if the user is currently on that page
        var projectUID = null;
        if(currentUrl.indexOf("/rfp/") != -1){
			projectUID = currentUrl.split("/rfp/")[1];
		}
		if(projectUID){
			$state.go("login",{ "next" : "project", "params":JSON.stringify({"uid":projectUID})});
		}else{
			$state.go("login", {});
		}
    }

    $scope.isNotLoggedIn = function(){
    	return $scope.user == undefined;
    }

    $scope.logOut = function(){
        $scope.deleteUser();
        $state.go('index', {});
    }

    $rootScope.hideNavBar = function(){
        var myNav = $("#my-nav");
        myNav.collapse('hide');
    }

});